import { Button } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { openGenericObjectModal } from "../ModalGenericObject/useGenericObjectModalStore";
import { fieldOsData } from "@/shared/utils/fields-modal-generic-object";

type OSDataProps = {
  os_data: string;
}
export default function OSData({ os_data }: OSDataProps) {

  if (!os_data) {
    return "—"
  }

  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {

          openGenericObjectModal({
            data: {
              os_data
            },
            fields: fieldOsData,
            title: "Información de Sustento",
            emptyFallback: "—",
          });
        }}
      >
        VER
      </Button>
    </>
  )
}